import { get } from 'lodash-es';
import { createSelector } from 'reselect';

const selectState = state => state.search;

const selectZipcodeData = createSelector(selectState, state =>
  get(state, 'zipcode'),
);

export const selectZipcode = createSelector(
  selectZipcodeData,
  zipcode => get(zipcode, 'value'),
);

export const selectIsZipcodeValid = createSelector(
  selectZipcodeData,
  zipcode => get(zipcode, 'isValid'),
);

export const selectRadius = createSelector(
  selectState,
  state => state.radius,
);

export const selectErrorMessage = createSelector(
  selectState,
  state => state.errorMessage,
);

export const selectIsSearching = createSelector(
  selectState,
  state => state.isLoading,
);

export const selectIsSearchActive = createSelector(
  selectState,
  state => state.isActive,
);
